import React from 'react';
import {
  ClockCircleOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  QuestionCircleOutlined,
  ScheduleOutlined,
  UserOutlined,
} from '@ant-design/icons';

/* eslint-disable camelcase */
const statusConfig = {
  open: {
    icon: <ClockCircleOutlined style={{ color: '#00B8D9' }} />,
    color: '#00B8D9',
    bg: '#E6FCFF',
  },
  taken: {
    icon: <UserOutlined style={{ color: '#0052CC' }} />,
    color: '#0052CC',
    bg: '#DEEBFF',
  },
  clarification: {
    icon: <QuestionCircleOutlined style={{ color: '#FF8B00' }} />,
    color: '#FF8B00',
    bg: '#FFF4E5',
  },
  on_roadmap: {
    icon: <ScheduleOutlined style={{ color: '#5243AA' }} />,
    color: '#5243AA',
    bg: '#EAE6FF',
  },
  in_progress: {
    icon: <PlayCircleOutlined style={{ color: '#0052CC' }} />,
    color: '#0052CC',
    bg: '#DEEBFF',
  },
  on_review: {
    icon: <EyeOutlined style={{ color: '#FFAB00' }} />,
    color: '#FFAB00',
    bg: '#FFFAE6',
  },
  done: {
    icon: <CheckCircleOutlined style={{ color: '#36B37E' }} />,
    color: '#36B37E',
    bg: '#E3FCEF',
  },
  rejected: {
    icon: <CloseCircleOutlined style={{ color: '#6B778C' }} />,
    color: '#6B778C',
    bg: '#F4F5F7',
  },
};
/* eslint-enable camelcase */

export default statusConfig;
